import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { actions as recordingsActions } from '../../../Reducks/Recordings';
import { connect } from 'react-redux';
import { MAX_RANGE, MIN_RANGE, RecordingSource } from '../../../Utils/Constants';
import { ResponsiveModal } from '@getgo/chameleon-react';
import { Button, Popover, PopoverBody } from 'reactstrap';
import RangeSelectorComponent from '../../../Components/RangeSelector/RangeSelectorComponent';
import './RecordingsRangeFilter.css';
import {
  trackAnalyticsFeature,
  trackAnalyticsFilterType,
  trackAnalyticsGenerateReportFeature
} from '../../../Telemetry/Mixpanel/Features/analyticsTracker';
import {
  SHARES,
  FILTER,
  VIEWS,
  VALUE_ADD,
  RECORDING_SOURCE
} from '../../../Telemetry/Mixpanel/Constants/mixpanelConstants';
import { isArrayEqual, isArrayEqualUnsorted } from '../../../Utils/ArrayUtils';
import FilterButton from '../../../Components/FilterButton/FilterButton';

export class RecordingsRangeFilter extends Component {
  static propTypes = {
    isBig: PropTypes.bool.isRequired,
    uniqueId: PropTypes.string.isRequired,
    reduced_recordings: PropTypes.object,
    mixpanelData: PropTypes.shape({
      action: PropTypes.string.isRequired,
      reportType: PropTypes.string
    }),
    filterRecordingsByCount: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      isRangeFilterOpen: false,
      viewsRange: [MIN_RANGE, MAX_RANGE],
      sharesRange: [MIN_RANGE, MAX_RANGE],
      sources: [RecordingSource.G2S, RecordingSource.G2W, RecordingSource.G2S_EMBEDDED],
      isViewsRangeValid: true,
      isSharesRangeValid: true,
      resetValid: false
    };
  }

  updateViewsRange = viewsRange => {
    this.setState({ viewsRange });
  };

  updateSharesRange = sharesRange => {
    this.setState({ sharesRange });
  };

  setViewsRangeValidity = isViewsRangeValid => {
    this.setState({ isViewsRangeValid });
  };

  setSharesRangeValidity = isSharesRangeValid => {
    this.setState({ isSharesRangeValid });
  };

  toggleRangeFilter = () => {
    if (!this.state.resetValid) {
      this.setState({
        viewsRange: this.props.reduced_recordings.filter.viewsRange,
        sharesRange: this.props.reduced_recordings.filter.sharesRange,
        sources: this.props.reduced_recordings.filter.sources
      });
    }
    this.setState(state => ({ isRangeFilterOpen: !state.isRangeFilterOpen }));
  };

  componentDidMount() {
    const { viewsRange, sharesRange, sources } = this.props.reduced_recordings.filter;

    if (
      !isArrayEqual(viewsRange, this.state.viewsRange) ||
      !isArrayEqual(sharesRange, this.state.sharesRange) ||
      !isArrayEqual(sources, this.state.sources)
    ) {
      this.setState({
        viewsRange,
        sharesRange,
        sources
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { viewsRange, sharesRange, sources } = this.props.reduced_recordings.filter;

    if (
      !isArrayEqual(viewsRange, prevProps.reduced_recordings.filter.viewsRange) ||
      !isArrayEqual(sharesRange, prevProps.reduced_recordings.filter.sharesRange) ||
      !isArrayEqual(sources, prevProps.reduced_recordings.filter.sources)
    ) {
      this.setState({
        viewsRange,
        sharesRange,
        sources
      });
    }
  }

  static contextTypes = {
    t: PropTypes.func.isRequired
  };

  render() {
    const { isBig } = this.props;
    let { recordings, filter } = this.props.reduced_recordings;
    let filterDisabled =
      recordings && ((recordings.allKeys && recordings.allKeys.length === 0) || this.props.reduced_recordings.fetching);
    let recordingsRangeFilterCount = this.getRecordingsRangeFilterCount(filter);
    return (
      <div id={this.props.uniqueId}>
        <FilterButton
          isBig={isBig}
          rangeFilterCount={recordingsRangeFilterCount}
          filterDisabled={filterDisabled}
          onClick={this.toggleRangeFilter}
        />
        {isBig ? this.getDefaultRender() : this.getMobileRender()}
      </div>
    );
  }

  getRecordingsRangeFilterCount = recordingsFilter => {
    let recordingsRangeFilterCount = 0;
    if (!isArrayEqual(recordingsFilter.viewsRange, [MIN_RANGE, MAX_RANGE])) {
      recordingsRangeFilterCount += 1;
    }
    if (!isArrayEqual(recordingsFilter.sharesRange, [MIN_RANGE, MAX_RANGE])) {
      recordingsRangeFilterCount += 1;
    }
    if (
      !isArrayEqualUnsorted(recordingsFilter.sources, [
        RecordingSource.G2S,
        RecordingSource.G2W,
        RecordingSource.G2S_EMBEDDED
      ])
    ) {
      recordingsRangeFilterCount += 1;
    }
    return recordingsRangeFilterCount;
  };

  getMobileRender = () => {
    const { isRangeFilterOpen } = this.state;
    return (
      <ResponsiveModal isOpen={isRangeFilterOpen} onClose={() => this.setResetValidity(false)}>
        <div className="recordingsRangeFilterMobile">{this.getFilters()}</div>
      </ResponsiveModal>
    );
  };

  getDefaultRender = () => {
    const { isRangeFilterOpen } = this.state;
    return (
      <Popover
        className="recordingsRangeFilterPopover"
        isOpen={isRangeFilterOpen}
        placement="bottom"
        target={this.props.uniqueId}
        toggle={this.toggleRangeFilter}
        hideArrow={true}>
        <PopoverBody>
          <div>{this.getFilters()}</div>
        </PopoverBody>
      </Popover>
    );
  };

  getFilters = () => {
    const { t } = this.context;
    return (
      <div>
        <div className="filterHeading">
          <div className="filterTitle">{t('buttons.filter')}</div>
          <div className="filterDescription">{t('recordings.filter.filterTitle')}</div>
          <hr />
        </div>
        <div className="filterBody">
          {this.sourcesSelector()}
          <hr />
          <RangeSelectorComponent
            sectionTitle={t('recordings.filter.numberOfViews')}
            range={this.state.viewsRange}
            updateRange={this.updateViewsRange}
            className={'Registrants'}
            MIN_RANGE={MIN_RANGE}
            MAX_RANGE={MAX_RANGE}
            setValidity={this.setViewsRangeValidity}
          />
          <hr />
          <RangeSelectorComponent
            sectionTitle={t('recordings.filter.numberOfShares')}
            range={this.state.sharesRange}
            updateRange={this.updateSharesRange}
            className={'Attendees'}
            MIN_RANGE={MIN_RANGE}
            MAX_RANGE={MAX_RANGE}
            setValidity={this.setSharesRangeValidity}
          />
        </div>
        <div className="filterSubmissionSection">
          {this.resetButton()}
          <div className="applyAndCancel">
            {this.cancelButton()}
            {this.applyButton()}
          </div>
        </div>
      </div>
    );
  };
  sourcesSelector = () => {
    const { sources } = this.state;
    const { t } = this.context;
    return (
      <div className="sourcesSelector">
        <div className="sourcesTitle">{t('recordings.filter.sourceOfRec')}</div>
        <div>
          <div
            className={`custom-buttons-chameleon ${sources.includes(RecordingSource.G2W) ? '' : 'outline-button'}`}
            onClick={() => this.toggleSource(RecordingSource.G2W)}>
            {t('recordings.source.standalone')}
          </div>
          &nbsp;&nbsp;
          <div
            className={`custom-buttons-chameleon ${
              sources.includes(RecordingSource.G2S) && sources.includes(RecordingSource.G2S_EMBEDDED)
                ? ''
                : 'outline-button'
            }`}
            onClick={() => {
              this.toggleSource(RecordingSource.G2S);
              this.toggleSource(RecordingSource.G2S_EMBEDDED);
            }}>
            {t('recordings.source.goToStage')}
          </div>
        </div>
        <div className="subMessage">
          {isArrayEqualUnsorted([RecordingSource.G2W, RecordingSource.G2S, RecordingSource.G2S_EMBEDDED], sources) &&
            t('recordings.filter.showBoth')}
          {isArrayEqualUnsorted([RecordingSource.G2W], sources) && t('recordings.filter.showStandaloneOnly')}
          {isArrayEqualUnsorted([RecordingSource.G2S, RecordingSource.G2S_EMBEDDED], sources) &&
            t('recordings.filter.showG2SOnly')}
        </div>
      </div>
    );
  };
  toggleSource = source => {
    this.setState(state => ({
      sources: state.sources.includes(source) ? state.sources.filter(s => s !== source) : [...state.sources, source]
    }));
  };

  static isResetDisabled(viewsRange, sharesRange, sources) {
    return (
      isArrayEqual(viewsRange, [MIN_RANGE, MAX_RANGE]) &&
      isArrayEqual(sharesRange, [MIN_RANGE, MAX_RANGE]) &&
      isArrayEqual(sources, [RecordingSource.G2S, RecordingSource.G2W, RecordingSource.G2S_EMBEDDED])
    );
  }

  resetButton = () => {
    let { viewsRange, sharesRange, sources } = this.state;
    const { t } = this.context;
    return (
      <Button
        className="resetButton"
        color="link"
        disabled={RecordingsRangeFilter.isResetDisabled(viewsRange, sharesRange, sources)}
        onClick={this.reset}>
        {t('buttons.reset')}
      </Button>
    );
  };

  cancelButton = () => {
    const { t } = this.context;
    return (
      <Button className="cancelButton" onClick={() => this.setResetValidity(false)} color="link">
        {t('buttons.cancel')}
      </Button>
    );
  };

  applyButton = () => {
    let isInvalid = !this.state.isViewsRangeValid || !this.state.isSharesRangeValid;
    let { viewsRange, sharesRange, sources } = this.props.reduced_recordings.filter;

    let isDisabled =
      isInvalid ||
      (isArrayEqual(this.state.viewsRange, viewsRange) &&
        isArrayEqual(this.state.sharesRange, sharesRange) &&
        isArrayEqualUnsorted(this.state.sources, sources));
    const { t } = this.context;
    return (
      <Button className="applyButton" disabled={isDisabled} onClick={this.applyFilter} color={'link'}>
        {t('buttons.apply')}
      </Button>
    );
  };

  setResetValidity = isValid => {
    this.setState(
      {
        resetValid: isValid
      },
      function() {
        this.toggleRangeFilter();
      }
    );
  };
  applyFilter = () => {
    const { filter } = this.props.reduced_recordings;
    const filterOptions = {
      viewsRange: this.state.viewsRange,
      sharesRange: this.state.sharesRange,
      sources: this.state.sources
    };
    this.props.filterRecordingsByCount(filterOptions);
    this.setResetValidity(true);
    this.trackAnalytics(filter);
  };

  trackAnalytics = filter => {
    let sendEvent = false;
    if (!isArrayEqual(filter.viewsRange, this.state.viewsRange)) {
      sendEvent = true;
      trackAnalyticsFilterType(
        this.props.mixpanelData.action,
        VIEWS,
        this.state.viewsRange[0],
        this.state.viewsRange[1]
      );
    }
    if (!isArrayEqual(filter.sharesRange, this.state.sharesRange)) {
      sendEvent = true;
      trackAnalyticsFilterType(
        this.props.mixpanelData.action,
        SHARES,
        this.state.sharesRange[0],
        this.state.sharesRange[1]
      );
    }
    if (!isArrayEqualUnsorted(filter.sources, this.state.sources)) {
      sendEvent = true;
      trackAnalyticsFilterType(this.props.mixpanelData.action, RECORDING_SOURCE, '', '', this.state.sources.toString());
    }
    if (sendEvent) {
      trackAnalyticsFeature(VALUE_ADD, this.props.mixpanelData.action, FILTER);
      if (this.props.mixpanelData.reportType) {
        trackAnalyticsGenerateReportFeature(this.props.mixpanelData.reportType, FILTER);
      }
    }
  };

  reset = () => {
    const viewsRange = [MIN_RANGE, MAX_RANGE];
    const sharesRange = [MIN_RANGE, MAX_RANGE];
    const sources = [RecordingSource.G2W, RecordingSource.G2S, RecordingSource.G2S_EMBEDDED];
    this.setState({
      viewsRange,
      sharesRange,
      sources,
      isViewsRangeValid: true,
      isSharesRangeValid: true,
      resetValid: false
    });
  };
}

export default connect(
  state => ({
    reduced_recordings: state.reduced_recordings
  }),
  dispatch => ({
    filterRecordingsByCount: filterOptions => dispatch(recordingsActions.filterRecordingsByCount(filterOptions))
  })
)(RecordingsRangeFilter);



// WEBPACK FOOTER //
// ./src/GoToWebinar/Recordings/Filters/RecordingsRangeFilter.js